import { CustomImage } from '~/models'
import { Model } from './Model'

export class QAndA extends Model {

  public name!:          string
  public image!:         CustomImage | null
  public questionCount!: number

}